document.addEventListener("DOMContentLoaded", handleTabLists);

function handleTabLists() {
  const tabLists = document.querySelectorAll<HTMLElement>("[data-tab-list]");

  tabLists.forEach(handleTabList);

  // HELPERS
  function handleTabList(tabList: HTMLElement) {
    const radioButtons = tabList.querySelectorAll<HTMLInputElement>(
      'input[type="radio"]',
    );

    const panels = getPanels(radioButtons);
    resetPanels(panels); // Hide all panels initially

    radioButtons.forEach((radio) => handleRadioButton(radio, panels));
  }

  function getPanels(radioButtons: NodeListOf<HTMLInputElement>) {
    const panels: Array<HTMLElement> = [];
    radioButtons.forEach((radio) => {
      const panelTarget = radio.dataset.panelTarget;
      if (!panelTarget) return;

      const panel: HTMLElement | null = document.getElementById(panelTarget);
      if (!panel) return;
      panels.push(panel);
    });

    return panels;
  }

  function resetPanels(panels: Array<HTMLElement>) {
    panels.forEach((panel) => updatePanel(panel, false));
  }

  function handleRadioButton(
    radio: HTMLInputElement,
    panels: Array<HTMLElement>,
  ) {
    const panel = panels.find((p) => p.id === radio.dataset.panelTarget);
    if (!panel) return;

    updatePanel(panel, radio.checked); // Initial state
    radio.addEventListener("change", () =>
      updateAllPanels(panels, panel, radio.checked),
    );
  }

  function updatePanel(panel: HTMLElement, isVisible: boolean) {
    if (isVisible) {
      panel.classList.remove("hidden");
      panel.classList.add("block");
    } else {
      panel.classList.add("hidden");
      panel.classList.remove("block");
    }
  }

  function updateAllPanels(
    panels: Array<HTMLElement>,
    panel: HTMLElement,
    isVisible: boolean,
  ) {
    resetPanels(panels);
    updatePanel(panel, isVisible);
  }
}
